import React from "react";
import { TourneyTile } from "@themed-components";

function TourneyDetailsTargetTourney({ selectedTourneyDetails }) {
  const {
    parentTourney,
    lateRegistrationAllowed,
    childTourneys = [],
  } = selectedTourneyDetails;

  return !parentTourney ? (
    <div>
      <div className={`h-80 flex flex-col items-center justify-center`}>
        <div className={`text-sm text-secondary mt-4`}>
          No Tourney Available
        </div>
      </div>
    </div>
  ) : (
    <div>
      {/* section 1 */}
      <TourneyTile
        game={selectedTourneyDetails?.parentTourney || ""}
        // isLateReg={lateRegistrationAllowed}
        isLateReg={
          lateRegistrationAllowed &&
          selectedTourneyDetails?.tourneyStartTime * 1000 <
            new Date().getTime() &&
          selectedTourneyDetails?.lateRegEndTime * 1000 > new Date().getTime()
            ? true
            : false
        }
        // status={"lateRegistration"}
      />
      {childTourneys?.map((Id, index) => (
        <TourneyTile
          key={Id}
          game={Id || ""}
          isLateReg={
            lateRegistrationAllowed &&
            selectedTourneyDetails?.tourneyStartTime * 1000 <
              new Date().getTime() &&
            selectedTourneyDetails?.lateRegEndTime * 1000 > new Date().getTime()
              ? true
              : false
          }
        />
      ))}
    </div>
  );
}

export default TourneyDetailsTargetTourney;
